/**
 * Created by jv on 18/01/2017.
 */
const LanguageManager = require("Sources/services/languagemanager");
const utils = require("Sources/utils/utils");
const elementCreator = require("Sources/components/element-creator");
var template = {};

(function(Template)
{
  Template.defaultHeaderTemplate = function(data, options)
  {
    options = utils.isNotNull(options) ? options : {};
    options.cellClasses = utils.isArray(options.cellClasses) ? options.cellClasses : [ "fo-cell", "header" ];
    options.rowClasses = utils.isArray(options.rowClasses) ? options.rowClasses : [ "fo-row" ];

    var cellElements = "";

    for(var i = 0; i < data.length; i++)
    {
      var cellElementInnerHTML = LanguageManager.getValueForKey(data[i].displayText);
      var cellElementAttributes = data[i].attributes;

      if(data[i].sortable && options.sortable)
      {
        cellElementInnerHTML = createTableHeaderSortCell(data[i]);
        // If sortable --> attributes go on the span with the cell text
        cellElementAttributes = [];
      }

      cellElements += elementCreator.createStringElement({
        classNames: options.cellClasses,
        attributes: cellElementAttributes,
        innerHTML: cellElementInnerHTML
      });
    }

    var row = elementCreator.createStringElement({
      classNames: options.rowClasses,
      innerHTML: cellElements
    });

    return row;
  };

  function createTableHeaderSortCell(data)
  {
    data.sortAttributes = utils.isArray(data.sortAttributes) ? data.sortAttributes : [];

    // Will be overridden if data-sort-property is set in the headers json file
    // Why? order.created returns the date formatted as a string but we want _created so that we get the moment object
    data.sortAttributes.push({
      name: "data-sort",
      value: data.key
    });

    var sortLinkText = elementCreator.createStringElement({
      tagName: "span",
      attributes: data.attributes,
      innerHTML: LanguageManager.getValueForKey(data.displayText)
    });

    var sortLinkIcons = elementCreator.createStringElement({
      tagName: "span",
      classNames: [ "sort-icons" ]
    });

    var sortLink = elementCreator.createStringElement({
      tagName: "span",
      classNames: [ "sort-link" ],
      attributes: data.sortAttributes,
      innerHTML: sortLinkText + sortLinkIcons
    });

    return sortLink;
  }

  Template.defaultBodyTemplate = function(headerKeys, data, options)
  {
    options = utils.isNotNull(options) ? options : {};
    options.cellClasses = utils.isArray(options.cellClasses) ? options.cellClasses : [ "fo-cell" ];
    options.rowClasses = utils.isArray(options.rowClasses) ? options.rowClasses : [ "fo-row" ];

    if(utils.isNotNull(options.rowIdProperty) && !data.hasOwnProperty(options.rowIdProperty))
    {
      return "";
    }

    var cellElements = "";

    data._filterValues = [];

    for(var j = 0; j < headerKeys.length; j++)
    {
      // Getters do not count for hasOwnProperty ...
      // if(data.hasOwnProperty(headerKeys[j]))
      var cellValue = data[headerKeys[j]];

      if(utils.isNull(cellValue))
      {
        cellValue = "";
      }

      cellValue = LanguageManager.getValueForKey(cellValue);
      data._filterValues.push(cellValue);

      cellElements += elementCreator.createStringElement({
        classNames: options.cellClasses,
        innerHTML: cellValue
      });
    }

    var row = elementCreator.createStringElement({
      classNames: options.rowClasses,
      attributes: [
        {
          "name": "data-row-" + options.rowIdProperty,
          "value": data[options.rowIdProperty]
        }
      ],
      innerHTML: cellElements
    });

    return row;
  };
}(template));

module.exports = template;



// WEBPACK FOOTER //
// ./app/js/templates/fundels-table.template.js